<div class="action_detail_box">
  <div class="header">
    <h3>{{title}}</h3>
    <ion-icon class="close_icon" name="dp-close" (click)="close()"></ion-icon>
  </div>

  <div class="content">
    <!-- Mostrar datos JSON formateados -->
    <div *ngIf="isJsonData" class="json-data">
      <div class="data-section" *ngFor="let key of getObjectKeys(formattedJsonData)">
        <div class="data-label">{{key}}:</div>
        <div class="data-value">
          <pre *ngIf="isObject(formattedJsonData[key])">{{formatValue(formattedJsonData[key])}}</pre>
          <span *ngIf="!isObject(formattedJsonData[key])">{{formattedJsonData[key]}}</span>
        </div>
      </div>
    </div>

    <!-- Mostrar texto simple -->
    <div *ngIf="!isJsonData" class="text-data">
      <pre>{{actionData}}</pre>
    </div>
  </div>

  <div class="buttons_box">
    <ion-button class="primary" mode="ios" fill="clear" size="small" (click)="close()">
      Cerrar
    </ion-button>
  </div>
</div>